module.exports = __webpack_public_path__ + "media/images/top/qa/logo-ff708761c8857ead2cbf81aeeb965b51.png";